import webBackApi from '../../api/webBackApi';

export const getFirstImageCandidate = async (feedId) => {
  const response = await webBackApi.get(`/api/iframe-config/${feedId}/first-image`);
  return response.data; // { path, url, date, accepted }
};

export const setFirstImage = async (feedId, path) => {
  const response = await webBackApi.post(`/api/iframe-config/${feedId}`, { path });
  return response.data; // { path, url, date, accepted: true }
};

export const getDailyImages = async (feedId, date) => {
  const response = await webBackApi.get(`/api/s3-images/${feedId}/daily`, {
    params: { date },
  });
  return response.data;
};

export const getImageRange = async (ftpUserId, { period, customStart, customEnd } = {}) => {
  const params = { period };
  if (period === 'CUSTOM') {
    params.customStart = customStart;
    params.customEnd = customEnd;
  }
  const response = await webBackApi.get(`/api/iframe-config/${ftpUserId}/image-range`, { params });
  return response.data; // { period, rangeStart, rangeEnd, firstImage, lastImage }
};
